import * as Sentry from '@sentry/capacitor';
import { Capacitor } from '@capacitor/core';
import { PAYMASH_PROFILE } from '@profile';
import {
  breadcrumbsIntegration,
  browserTracingIntegration,
  browserProfilingIntegration,
  init,
  consoleLoggingIntegration,
  extraErrorDataIntegration,
} from '@sentry/angular';

// sentryEnvironment: 'development'
export const initSentry = () => {
  const isDev = PAYMASH_PROFILE.sentryEnvironment === 'development';
  const isIOS = Capacitor.getPlatform() === 'ios';

  Sentry.init(
    {
      dsn: PAYMASH_PROFILE.sentryUrl,
      environment: PAYMASH_PROFILE.sentryEnvironment,
      // Benign business signals that must never reach Sentry (they are still logged locally as info).
      // Matches the Error message; extend this list for other expected, non-actionable conditions.
      ignoreErrors: ['SHIFT MUST BE OPEN'],
      integrations: [
        breadcrumbsIntegration({
          console: false,
          xhr: false,
        }),

        ...(isIOS
          ? []
          : [
              browserTracingIntegration({
                instrumentNavigation: true,
              }) as any,
              browserProfilingIntegration(),
            ]),

        extraErrorDataIntegration({
          depth: 10,
        }),

        ...(isDev ? [consoleLoggingIntegration({ levels: ['warn', 'error'] })] : []),
      ],

      tracesSampleRate: isIOS ? 0 : 1.0,
      profilesSampleRate: isIOS ? 0 : 1.0,
      enableLogs: isDev,
    },
    init
  );
};
